export class TermsAndConditions {
    url: string;

    constructor(blob: Blob, header: Headers | undefined) {
        this.url = URL.createObjectURL(blob);
    }
}